import createPlugin from '@@/create-plugin';

export default createPlugin({
    components: {
        'block:api': () => import('./components/api'),
        'plugin:setting': () => import('./components/setting'),
        'editor:tool': () => import('./components/tool')
    }
});
